import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Brand context — selected brand for non-full users.
 *
 * Full users (admin/master) keep DashboardPage as `/` and ignore this state
 * for routing. Non-full users get `/` redirected to `/brand/:selectedBrandId`
 * by OnboardingGate. The TopBar WorkspaceSwitcher writes here for everyone.
 *
 * Persisted under `xotski.brandContext` (separate key from auth/sidebar).
 */
interface BrandContextState {
  selectedBrandId: number | null;
  setSelectedBrandId: (id: number | null) => void;
  clear: () => void;
}

export const useBrandContextStore = create<BrandContextState>()(
  persist(
    (set) => ({
      selectedBrandId: null,
      setSelectedBrandId: (id) => set({ selectedBrandId: id }),
      clear: () => set({ selectedBrandId: null }),
    }),
    {
      name: 'xotski.brandContext',
      partialize: (s) => ({ selectedBrandId: s.selectedBrandId }),
    },
  ),
);

export function useSelectedBrandId(): number | null {
  return useBrandContextStore((s) => s.selectedBrandId);
}
